module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Grenade_C.ffd77567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Throwable/Item_Weapon_Grenade_C.png
// module id = 258
// module chunks = 0